// FaroRouteTracker — emits a RUM event on every route change. Render once
// inside the Router (BrowserRouter). Renders nothing.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackRoute } from "./faro";

export default function FaroRouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackRoute(location.pathname + (location.search || ""));
  }, [location.pathname, location.search]);
  return null;
}
